import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AccessibilityButton from "@/components/AccessibilityButton";
import HomePage from "@/pages/HomePage";
import OfficesPage from "@/pages/OfficesPage";
import CoworkingPage from "@/pages/CoworkingPage";
import ConferencePage from "@/pages/ConferencePage";
import ContactPage from "@/pages/ContactPage";
import AccessibilityPage from "@/pages/AccessibilityPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/offices" element={<OfficesPage />} />
            <Route path="/coworking" element={<CoworkingPage />} />
            <Route path="/conference" element={<ConferencePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
          </Routes>
        </main>
        <Footer />
        <AccessibilityButton />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
